module.exports = __webpack_public_path__ + "static/media/thermostatArrowDown.00472e10.png";